import { Action } from 'redux';
import { AppointmentDetailReport } from 'model/BookingsReport';

//Action Types
export const APPOINTMENT_DETAIL_REPORT_GET_START = 'APPOINTMENT_DETAIL_REPORT_GET_START';
export const APPOINTMENT_DETAIL_REPORT_GET_SUCCESS = 'APPOINTMENT_DETAIL_REPORT_GET_SUCCESS';
export const APPOINTMENT_DETAIL_REPORT_GET_ERROR = 'APPOINTMENT_DETAIL_REPORT_GET_ERROR';

//Actions

type AppointmentsDetailReportGetStartAction = Action<typeof APPOINTMENT_DETAIL_REPORT_GET_START>;

interface AppointmentsDetailReportGetSuccessAction extends Action<typeof APPOINTMENT_DETAIL_REPORT_GET_SUCCESS> {
    payload: {
        items: Array<AppointmentDetailReport>;
        page?: number | string;
        size?: number | string;
        totalPages?: number | string;
        totalRecords?: number | string;
    };
}

type AppointmentsDetailReportErrorAction = Action<typeof APPOINTMENT_DETAIL_REPORT_GET_ERROR>;

export type AppointmentsDetailReportAction =
    | AppointmentsDetailReportGetStartAction
    | AppointmentsDetailReportGetSuccessAction
    | AppointmentsDetailReportErrorAction;
